import { render } from "./BaseTab.vue?vue&type=template&id=00928d7a&scoped=true&ts=true"
import script from "./BaseTab.vue?vue&type=script&lang=ts"
export * from "./BaseTab.vue?vue&type=script&lang=ts"

import "./BaseTab.vue?vue&type=style&index=0&id=00928d7a&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00928d7a"]])

export default __exports__